import { Trans } from "react-i18next";
import { dt } from "@/daily/strings";
import { PlaneIcon } from "./icons";
import { Sheet } from "./Sheet";

interface HelpScreenProps {
  onClose: () => void;
}

// How to play: a sheet rising from the bottom on a phone, a dialog on
// desktop, with the map still showing behind it. Shown on a player's first
// visit, and again from the help button.
export const HelpScreen = ({ onClose }: HelpScreenProps) => (
  <Sheet labelledBy="ds-help-title" onClose={onClose}>
    {(close) => (
      <>
        <span className="ds-eyebrow ds-eyebrow--red ds-help__eyebrow">
          Daily Service · {dt("howToPlay")}
        </span>
        <h1 id="ds-help-title" className="ds-help__title">
          {dt("helpTitle")}
        </h1>
        <hr className="ds-help__rule" />

        <ol className="ds-help__steps">
          <li>
            <span className="ds-help__number">1</span>
            <span>
              <Trans i18nKey="daily.helpStep1" components={{ 1: <strong /> }} />
            </span>
          </li>
          <li>
            <span className="ds-help__number">2</span>
            <span>
              <Trans i18nKey="daily.helpStep2" components={{ 1: <strong /> }} />
            </span>
          </li>
          <li>
            <span className="ds-help__number">3</span>
            <span>
              <Trans i18nKey="daily.helpStep3" components={{ 1: <strong /> }} />
            </span>
          </li>
        </ol>

        <button
          type="button"
          className="ds-button ds-button--red ds-help__button"
          onClick={close}
          autoFocus
        >
          {dt("helpButton")}
          <PlaneIcon size={16} />
        </button>
      </>
    )}
  </Sheet>
);
